export default {
  dashboardSection: {
    greenBeansData: "Gestión de Granos Verdes",
    greenCoffee: "Café Verde",
    dryMilling: "Molienda en Seco",
    modules: "Módulos",
    allowances: "Subsidios",
    maxUserAllowed: "Máximo de usuarios con permiso",
    satelliteReportsAllowed: "Informes por satélite permitidos ",
    advanceReport: "Informes avanzados permitidos",
    subscriptionUpTo: "Suscripción hasta",
    roleAllowed: "Puestos con permiso ",
    moduleAllowed: "Módulos permitidos ",
    registeredUsers: "Usuarios registrados",
    validMemberships: "Membresía válida",
    activeUsers: "Usuarios activos",
    deactivatedUsers: "Usuarios desactivados",
    membershipValidity: "Validez de la membresía",
    lessThan1Month: "Menos de 1 mes",
    months1to6: "1-6 meses",
    months6to12: "6-12 meses",
    moreThan1Year: "Menos de 1 mes ",
    cropOverview: "Visión general del cultivo",
    plantations: "Plantaciones ",
    coffeeData: "Datos del café",
    availableModules: "Módulos disponibles",
    roleList: "Granjero, central de compras, almacén",
    memberData: "Datos de Miembro",
    userType: "Tipo de Usuario",
    registered: "Registrado",
    offlineUsers: "Usuarios Desconectados",
    lessThanOneMonth: "< 1 Mes",
    cacaoData: "Datos de Cacao",
    dryCacao: "Cacao Seco",
    traceability: "Trazabilidad",
  },
  greenBeansData: {
    notFound: "No se encontraron datos",
  },
  dashboardReports: {
    appDataReports: "Informes de Datos de la Aplicación",
    reports: "Informes",
  },
}